import React, { useState } from 'react';
import Projects from "../Projects"
import Footer from "../Footer"
import "../../App.css"

const Work = () => {
    return (
        <>
            <Projects />
            <Footer />
        </>

    )
}

export default Work